<script>
  import {mapGetters} from 'vuex';
  import template from './template.html';
  import './style.scss';
  import { serialize } from './serialize';
  import {isEmpty} from 'lodash';

  export default {

    template,

    name: "AcclaroNoResultsRow",

    props: ['props'],

    computed: {

      ...mapGetters('AcclaroSearchStore', [
        'query',
      ]),

      links () {
        return this.props.opts.noResultsSearchLinks;
      },

      hasNoResultsLinks () {
        return !isEmpty(this.links);
      },
    },

    data () {
      return {};
    },

    methods: {

      generateUrl (url, params) {
        let paramOpts = Object.assign({}, params, {
          search: this.query
        });

        let serializedParams = serialize(paramOpts);

        return `${url}?${serializedParams}`;
      },

      resetFilter () {
        window.location.href = window.location.pathname + '?filter=clear';
      }
    }
  }
</script>
